var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"flat":_vm.flat,"fab":_vm.fab,"small":_vm.small,"block":_vm.block,"icon":_vm.icon,"dark":_vm.dark && !(_vm.pasif || _vm.disabled),"disabled":_vm.pasif || _vm.disabled},on:{"click":_vm.tikla}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t("save_button")))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }